import Vue from "vue";
import VueClipboard from 'vue-clipboard2'
import DashboardPlugin from "./material-dashboard";
import store from "./store/index";
import router from "./router";
import axios from "axios";
import moment from "vue-moment";
import Notifications from "./components/NotificationPlugin";
import auth from "@/services/auth";

axios.defaults.baseURL = process.env.VUE_APP_API_HOST; //"http://localhost:9989";

if (auth.isLoggedIn()) {
  var token = auth.getToken();
  axios.defaults.headers.common["Authorization"] = `Bearer ${token.Token}`;
}

// Capture and show error messages
axios.interceptors.response.use(
  response => {
    if (response.headers.authorization) {
      // let _token = response.headers.authorization
      // storage.saveToken(response.headers.authorization.replace('Bearer ', ''))
    }
    return response; // successful response
  },
  error => {
    console.log(error, error.response)
    // API error responses carry an `Errors` array, but network failures
    // (no `error.response`) and unexpected error shapes don't. Guard those
    // so the interceptor never throws and callers always receive an array
    // of strings to iterate over.
    var errors =
      error.response &&
      error.response.data &&
      Array.isArray(error.response.data.Errors)
        ? error.response.data.Errors
        : [error.message || "An unexpected error occurred. Please try again."];
    errors.forEach(e => {
      //showError(e)
      console.log(e);
    });
    return Promise.reject(errors);
  }
);

// Plugins
import App from "./App.vue";
// import Chartist from "chartist";

var filter = function(text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter("truncate", filter);

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(moment);
Vue.use(Notifications);
Vue.use(VueClipboard);

// global library setup
/* Object.defineProperty(Vue.prototype, "$Chartist", {
  get() {
    return this.$root.Chartist;
  }
}); */

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  data: {
    // Chartist: Chartist
  }
});
